import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".screen-404"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".logo-header"
  }, /* @__PURE__ */ jsx("a", {
    attrs: { href: `https://mixpanel.com` }
  }, /* @__PURE__ */ jsx("img", {
    attrs: { width: `144`, height: `48`, src: `/site_media/images/mp2023-logo.svg` }
  }))), /* @__PURE__ */ jsx("img", {
    sel: ".error-pie",
    attrs: { width: `1120`, height: `308`, src: `/site_media/images/error_pages/error_pie.png` }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".not-found-area"
  }, /* @__PURE__ */ jsx("h1", null, "Page not found"), /* @__PURE__ */ jsx("h2", null, "We\u2019re thinking this isn\u2019t the page you want..."), /* @__PURE__ */ jsx("p", null, "There is nothing at this URL. Try checking the address or go to:", /* @__PURE__ */ jsx("div", null, this.helpers.shouldShowDashboardLink() && /* @__PURE__ */ jsx("span", null, /* @__PURE__ */ jsx("a", {
    href: "/report/dashboard"
  }, "Your Board"), ","), /* @__PURE__ */ jsx("a", {
    href: "https://help.mixpanel.com"
  }, " Help Center"), ",", /* @__PURE__ */ jsx("a", {
    href: "https://mixpanel.com/community-slack"
  }, ` `, "Mixpanel Community")))));
}
